import { MRT_Row, MRT_TableInstance } from "material-react-table";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { RoomlayoutServiceRow } from "./Domain/Types/FacilityService-Roomlayout-row.types";

type Props = {
  table: MRT_TableInstance<RoomlayoutServiceRow>;
  row: MRT_Row<RoomlayoutServiceRow>;
  setIsDeleteModalOpen: (o: boolean) => void;
  setDeletionSelected: (s: number[]) => void;
};
export const RoomlayoutListRowActions = ({
  table,
  row,
  setIsDeleteModalOpen,
  setDeletionSelected
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box data-testid="roomlayout-list-row-box" sx={{ display: "flex", gap: "1rem" }}>
      <Tooltip
        data-testid="roomlayout-list-row-edit"
        title={<Typography>{t("Edit")}</Typography>}
        aria-label={"Edit"}
      >
        <IconButton
          data-testid="roomlayout-list-row-edit-btn"
          onClick={() => table.setEditingRow(row)}
          size="large"
        >
          <Edit />
        </IconButton>
      </Tooltip>
      <Tooltip
        data-testid="roomlayout-list-row-delete"
        title={<Typography>{t("Delete")}</Typography>}
      >
        <IconButton
          data-testid="roomlayout-list-row-delete-btn"
          onClick={() => {
            setIsDeleteModalOpen(true);
            setDeletionSelected([row.original.id]);
          }}
          size="large"
        >
          <Delete />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
